<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="用户昵称:">
                        <el-input v-model="table.where.nick_name" placeholder="请输入用户昵称" clearable />
                    </el-form-item>
                    <el-form-item label="余额:">
                        <el-input-number v-model="table.where.price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入余额"
                            clearable />
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input v-model="table.where.phone" placeholder="请输入手机号" clearable />
                    </el-form-item>
                    <el-form-item label="会员权限:">
                        <el-select v-model="table.where.chmod" filterable placeholder="请选择">
                            <el-option label="普通用户" value="1"></el-option>
                            <el-option label="批发商" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                   <!-- <el-form-item label="排序:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:useropeninfo:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:useropeninfo:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:useropeninfo:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <el-table-column prop="nick_name" label="用户昵称" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    <el-table-column prop="avatarurl" label="用户头像" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.avatarurl"
                                :preview-src-list="[row.avatarurl]">
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="price" label="余额" sortable="custom" show-overflow-tooltip min-width="120" />
                    <el-table-column prop="chmod" label="会员权限" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.chmod == 1" :key="index">普通用户</el-tag>
                            <el-tag v-if="row.chmod == 2" :key="index">批发商</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gender" label="用户性别" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.gender == 0" :key="index">未知</el-tag>
                            <el-tag v-if="row.gender == 1" :key="index">男</el-tag>
                            <el-tag v-if="row.gender == 2" :key="index">女</el-tag>
                        </template>
                    </el-table-column>
                    
                   <!-- <el-table-column prop="province" label="用户省份" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    <el-table-column prop="city" label="用户城市" sortable="custom" show-overflow-tooltip min-width="120" />
 -->
                    <el-table-column prop="phone" label="手机号" sortable="custom" show-overflow-tooltip min-width="120" />

                    

                    <!-- <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="120" /> -->


                    <el-table-column label="注册时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:useropeninfo:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此会员列表吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:useropeninfo:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改会员列表':'添加会员列表'" :visible.sync="showEdit" width="800px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">

                <el-form-item label="用户昵称:" prop="nick_name">
                    <el-input v-model="editForm.nick_name" placeholder="请输入用户昵称" clearable />
                </el-form-item>

                <el-form-item label="余额:" prop="price">
                    <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                        :precision="4" class="ele-fluid ele-text-left" placeholder="请输入余额" clearable />
                </el-form-item>
                <el-form-item label="用户性别:" prop="gender">
                    <el-select v-model="editForm.gender" filterable placeholder="请选择用户性别">
                        <el-option label="未知" value="0"></el-option>
                        <el-option label="男" value="1"></el-option>
                        <el-option label="女" value="2"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="用户头像:" prop="avatarurl">
                    <ele-uploadimage :limit="1" v-model="editForm.avatarurl"></ele-uploadimage>

                </el-form-item>
               <!-- <el-form-item label="用户省份:" prop="province">
                    <el-input v-model="editForm.province" placeholder="请输入用户省份" clearable />
                </el-form-item>
                <el-form-item label="用户城市:" prop="city">
                    <el-input v-model="editForm.city" placeholder="请输入用户城市" clearable />
                </el-form-item> -->
                <el-form-item label="手机号:" prop="phone">
                    <el-input v-model="editForm.phone" placeholder="请输入手机号" clearable />
                </el-form-item>
                <el-form-item label="会员权限:" prop="chmod">
                    <el-select v-model="editForm.chmod" filterable placeholder="请选择会员权限">
                        <el-option label="普通用户" value="1"></el-option>
                        <el-option label="批发商" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="排序:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'

    export default {
        name: "SysUserOpeninfo",
        components: {
            EleUploadimage,
        },
        data() {
            return {
                table: {
                    url: '/user/UserOpeninfo/index',
                    where: {
                        "avatarurl": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "avatarurl": []
                }, // 表单数据
                editFormTemp: {
                    "avatarurl": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                editRules: { // 表单验证规则

                    openid: [{
                        required: true,
                        message: '请选择用户openid',
                        trigger: 'blur'
                    }],


                    nick_name: [{
                        required: true,
                        message: '请输入用户昵称',
                        trigger: 'blur'
                    }],


                    price: [{
                        required: true,
                        message: '请输入余额',
                        trigger: 'blur'
                    }],


                    gender: [{
                        required: true,
                        message: '请选择用户性别',
                        trigger: 'blur'
                    }],


                    avatarurl: [{
                        required: true,
                        message: '请上传用户头像',
                        trigger: 'blur'
                    }],


                    province: [{
                        required: true,
                        message: '请输入用户省份',
                        trigger: 'blur'
                    }],


                    city: [{
                        required: true,
                        message: '请输入用户城市',
                        trigger: 'blur'
                    }],


                    phone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }],


                    chmod: [{
                        required: true,
                        message: '请选择会员权限',
                        trigger: 'blur'
                    }],


                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],


                    sort: [{
                        required: true,
                        message: '请输入排序',
                        trigger: 'blur'
                    }],


                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {

        },
        methods: {
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/user/UserOpeninfo/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/user/UserOpeninfo/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的会员列表吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/user/UserOpeninfo/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/user/UserOpeninfo/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },

        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
